module.exports = __webpack_public_path__ + "static/icon-sri.78b07cf6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-sri.svg
// module id = 563
// module chunks = 52470039999506